<template>
    <div class="app-dashboard">
        <div class="vx-row">
            <div class="vx-col lg:w-2/3 w-full mb-base">
                <vx-card title="Mes Demandes" collapse-action refresh-content-action @refresh="closeCardAnimationDemo">
                    <div slot="no-body">
                        <div class="vx-row text-center">
                            <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                                <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                                    <h1 class="font-bold text-6xl"> {{affiche.totalRequest}} </h1>
                                    <small>Demandes envoyées</small>
                                </div>
                            </div>
                            <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                                <vue-apex-charts
                                        type=radialBar
                                        height=300 :options="requestsData.chartOptions"
                                        :series="requestsData.series"
                                />
                            </div>
                        </div>
                        <div class="flex flex-row justify-between px-8 pb-4 mt-4">
                            <p class="text-center" v-for="(val, key) in requestsData.meta" :key="key">
                                <span class="block">{{ key }}</span>
                                <span class="text-3xl font-semibold">{{ val }}</span>
                            </p>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col lg:w-1/3 w-full mb-base">
                <vx-card>
                    <template slot="no-body">
                        <div class="p-8 clearfix">
                            <div>
                                <small>{{ bills.event ? bills.event : '' }}</small>
                                <h1><span>{{ bills.total  ? bills.total : 0 }} F</span></h1>
                            </div>
                            <p class="mt-2 mb-8 text-xl font-medium text-primary">
                                <small>Réglé : </small>
                                <span>{{ bills_not_sold ? bills_not_sold : 0 }}</span>
                            </p>
                            <vs-button icon-pack="feather" icon="icon-chevrons-right" icon-after class="shadow-md w-full">Tous les règlements</vs-button>
                        </div>
                        <div class="p-8 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                            <div class="mb-4">
                                <div>
                                    <small>Total dû: <strong>{{ bills.total ? bills.total : 0 }} F</strong></small><br>
                                    <small>Total réglé: <strong>{{ bills_not_sold ? bills_not_sold : 0 }} F</strong></small>
                                </div>
                            </div>
                        </div>
                    </template>
                </vx-card>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card title="Dernières demandes">

                    <template slot="actions">
                        <vs-button color="primary" type="flat" @click="$router.push('/requests')">Toutes les demandes</vs-button>
                    </template>

                    <div slot="no-body" class="mt-4">
                        <vs-table :data="lastRequests" class="table-dark-inverted">
                            <template slot="thead">
                                <vs-th>DEMANDE</vs-th>
                                <vs-th>TYPE</vs-th>
                                <vs-th>OPERATEUR</vs-th>
                                <vs-th>STATUT</vs-th>
                                <vs-th>DATE DE CREATION</vs-th>
                                <vs-th>ACTIONS</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td>
                                        <span>{{data[indextr].title}}</span>
                                    </vs-td>
                                    <vs-td><span>{{ tr.type }}</span></vs-td>
                                    <vs-td>
                                        <ul class="users-liked user-list">
                                            <li>
                                                <vx-tooltip :text="tr.operator.name" position="bottom" v-if="tr.operator">
                                                    <vs-avatar :src="tr.operator.img" size="30px" class="border-2 border-white border-solid -m-1" />
                                                </vx-tooltip>
                                            </li>

                                        </ul>
                                    </vs-td>
                                    <vs-td>
                                        <vs-chip>{{ tr.status }}</vs-chip>
                                    </vs-td>
                                    <vs-td><span>{{ tr.created_at }}</span></vs-td>
                                    <vs-td>
                                        <span class="flex cursor-pointer hover:text-primary"  @click="goToSingle(tr.id, tr.has_proved)">
                                            <feather-icon
                                                icon="EyeIcon"
                                                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                class="mr-2"
                                            /> Détails
                                        </span>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
    var base_self;
    import VueApexCharts from 'vue-apexcharts';
    export default {
        components: {VueApexCharts},
        data() {
            return {
                affiche: {
                    perRequestEnd: 0,
                    totalApprobation: 0,
                    totalRequest: 0,
                    totalRequestEnd: 0,
                    totalRequestOnTreat: 0
                },
                bills: {},
                bills_not_sold: 0,
                requestsData: {
                    chartOptions: {
                        plotOptions: {
                            radialBar: {
                                size: 158,
                                offsetY: -30,
                                startAngle: -150,
                                endAngle: 150,
                                hollow: {
                                    size: '65%',
                                },
                                track: {
                                    background: "rgba(0,0,0,0)",
                                    strokeWidth: '100%',
                                },
                                dataLabels: {
                                    value: {
                                        offsetY: 30,
                                        color: '#067A2F',
                                        fontSize: '2rem'
                                    }
                                }
                            },
                        },
                        colors: ['#067A2F'],

                        stroke: {
                            dashArray: 8
                        },
                        chart: {
                            sparkline: {
                            }
                        },
                        labels: ['Demandes clôturées'],
                    },
                    series: [0],
                    meta: {
                        "Clôturées": 7,
                        "En cours de traitement": 4,
                        "En attente d'approbation": 2,
                    }

                },
                percent: 0,
                lastRequests: []
            }
        },
        methods: {

            goToSingle(id, el) {
                let t = el ? 1 : 2
                this.$router.push('/requests/' + id + '/detail/'+t)
            },

            closeCardAnimationDemo(card) {
                card.removeRefreshAnimation(2000);
            },
            async get_dashboard_customer_request_stats () {
                let response = await base_self.$store.state.dashboard_customer_request_stats({});

                base_self.affiche.perRequestEnd = response.data.perRequestEnd;
                base_self.affiche.totalRequestEnd = response.data.totalRequestEnd;
                base_self.affiche.totalRequestOnTreat = response.data.totalRequestOnTreat;

                base_self.affiche.totalApprobation = response.data.totalApprobation;
                base_self.affiche.totalRequest = response.data.totalRequest;

                base_self.requestsData.meta["Clôturées"] = response.data.totalRequestEnd;
                base_self.requestsData.meta["En cours de traitement"] = response.data.totalRequestOnTreat;
                base_self.requestsData.meta["En attente d'approbation"] = response.data.totalApprobation;

                var element = response.data.perRequestEnd;
                base_self.requestsData.series = [element.toFixed(2)];
            },
            async get_dashboard_customer_last_five_request () {
                let response = await base_self.$store.state.dashboard_customer_last_five_request({});
                base_self.lastRequests = response.data;
            },
            getBillInfo(){
                this.$http.get('/dashboard/customer/bills').then((response) => {
                    this.bills = response.data
                }).catch((error) =>{
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            },
            getBillInfoNotSold(){
                this.$http.get('/dashboard/customer/bills-not-sold').then((response) => {
                    this.bills_not_sold = response.data
                }).catch((error) =>{
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            }
        },
        mounted() {
            base_self.get_dashboard_customer_request_stats();

            base_self.get_dashboard_customer_last_five_request();

            base_self.getBillInfo()

            base_self.getBillInfoNotSold()
        },
        created() {
            base_self = this;
            window.ManagerDashboardApp = this;
        }
    }
</script>
